import React, { Component } from "react";
import { print } from 'shared/utils/Helpers';

export default class User {

  static instance = User.instance == null ? new User() : this.instance;

  constructor() {
    this.user = null; 
  }

  save(user){
    this.user = user;
  }

  get(){
    return this.user;
  }

}
